import React from "react";
import styles from '../../playlistSeeAll/PlayListSeeAll.module.css';
import { Skeleton } from '@mui/material';
import { useNavigate } from "react-router";

const AudioPlayListSeeAllLoading = () => {
  const navigate = useNavigate();
  const skeletonStyles = {
    backgroundColor: 'white',
    color: 'white', // Set the text color to white
  };

  const skeletonItems = Array.from({ length: 10 }, (_, index) => (
    <div key={index} className="relative h-20">
      <Skeleton
        variant="rectangular"
        className="rounded"
        width="100%"
        height="100%"
        sx={{ ...skeletonStyles }}
      />
    </div>
  ));

  return (
    <div className={`${styles.grid_cols_custom} grid`}>
      {skeletonItems}
    </div>
  );
};

export default AudioPlayListSeeAllLoading;
